import { render, staticRenderFns } from "./Spinner.vue.js?vue&type=template&id=497e87f6&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Spinner.vue?vue&type=template&id=497e87f6&scoped=true"
var script = {}
import style0 from "./Spinner.vue.css?vue&type=style&index=0&id=497e87f6&prod&scoped=true&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Spinner.vue?vue&type=style&index=0&id=497e87f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e87f6",
  null
  
)

export default component.exports